import { useEffect, useCallback, useState, useMemo } from "react";
import { useFormik, Form, FormikProvider, Field } from "formik";
import {
  Stack,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Select,
  FormHelperText,
  Card,
  Switch,
  Button,
  Box,
  FormLabel,
  RadioGroup,
  Radio,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import * as Yup from "yup";
import PlusCircleFill from "@iconify/icons-eva/plus-circle-fill";
import InputAdornment from "@mui/material/InputAdornment";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import downloadFill from "@iconify/icons-eva/download-fill";
import { LoadingButton, TabContext, TabPanel } from "@mui/lab";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useMatch,
  useLocation,
} from "react-router-dom";
import { Icon } from "@iconify/react";
import AlertCircleFill from "@iconify/icons-eva/alert-circle-fill";
import ClockFill from "@iconify/icons-eva/clock-fill";
import PlusFill from "@iconify/icons-eva/plus-fill";
import TrashOutline from "@iconify/icons-eva/trash-2-outline";
// import Countries from "../../data/countries.json";
import ConnectorType from "../../data/connectorType.json";
import { chargerFormValidationSchema } from "../../util/validationSchemas";
import "../../styles/charger.css";
import { useAccess } from "src/hooks/useAccess.hook";
import {
  ChargerFormTabs,
  NOTIFICATION_CONSTANTS,
  getChargerDefaultValues,
  hideForTabs,
  reportIssuesColumn,
  Direction,
  AllMessageStatus,
  AllTypes,
  AllStatus,
  chargerFieldToTab,
  chargerTabOrder,
  chargerTabLabels,
} from "./charger.constants";
import { useTabbedFormErrors } from "src/hooks/useTabbedFormErrors.hook";
import {
  chargerIdUrl,
  chargerUrl,
  getTeamUrl,
  viewLogsUrl,
  logFilterData,
  getTeamV3Url,
  getChargerInstructionBoardUrl,
  getChargerInstructionBoardConnectorUrl,
  getTeamUrlV2,
  assignChargerLicenseUrl,
  teamAvailableChargerLicensesUrl,
  teamChargerLicenseConfigUrl,
  initiateChargerLicenseSaleUrl,
} from "src/react-query/endPoints";
import { Loader } from "../Loader";
import { is } from "src/util/is";
import { useSelectedTeam, useSelectedCompany, useSelectedTeamState } from "src/hooks/useSelectedTeam";
import { useGetDetail, useMutate, useList } from "src/hooks/useFetch.hook";
import { useDispatch, useSelector } from "react-redux";
import enums, { FEATURE, getLicenseDurationLabel } from "src/util/enums";
import Address from "src/common/components/Address";
import { ChargerLicenseModal } from "src/common/components/ChargerLicenseModal";
import { StripePaymentModule } from "src/common/components/StripePaymentModule";
import { PaytmPaymentModule } from "src/common/components/PaytmPaymentModule";
import { selector } from "src/react-query/select";
import ImgPreviewModal from "../ImagePreviewModal/ImgPreviewModal";
import { getIcon } from "src/utils/utility";
import Token from "src/util/Token";

//actions
import { alertSlice } from "src/store/alert/alert.slice";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import { useInfiniteQuery, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchInfinite, fetchWithError } from "src/react-query/fetchWithError";
import { queryKeys } from "src/react-query/queryKeys";
import { LogsData, OldLogsData } from "./ViewLogsModal";
import { RemoteOperationForm } from "./RemoteOperation/RemoteOperationForm";
import { createYupSchema } from "src/utils/yupCreatorSchema";
import { remoteOperationConfig } from "./RemoteOperation/remoteOperationConfig";
import { remoteOperations } from "./RemoteOperation/remote.constants";
import { tabsCurrentlyOpenedForSlice } from "src/store/tabsOpened/tabsOpened.slice";
import RemoteOpsStatusModal from "./RemoteOperation/RemoteOpsStatusModal";
import { remoteOpsStatusSlice } from "src/store/remoteOpsStatus/remoteOpsStatus.slice";
import { GridLabel } from "../Transactions/TransactionView";
import { BaseTable } from "../BaseTable/BaseTable";
import axios from "../../util/axios";
import {
  isValidTimeInterval,
  yearFirstDateTimeFormat,
} from "src/utils/formatTime";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import RefreshFill from "@iconify/icons-eva/refresh-fill";
import { downloadCSV } from "src/utils/convertAnddownloadCsv";
import { PAYMENT_GATEWAY, PAYMENT_TYPE } from "src/util/enums";
import { PDFDocument } from "pdf-lib";
import QRCode from "qrcode";
import sanitizeValues from "src/utils/sanitizeValues";
import ChargerConfigModal from "./ChargerConfigModal";

const {
  actions: { setAlert },
} = alertSlice;

const initialConnectors = [
  { connectorId: "", kw: "", volt: "", connectorType: "", connectorName: "" },
];

const initialFaq = [{ question: "", answer: "" }];

const downloadRazorPayQR = (url) => {
  const link = document.createElement("a");
  link.download = "PaymentQR.jpeg";
  link.href = url;
  link.click();
};

const downloadCMQR = (value) => {
  const qrCode = document.getElementById(`chargerqr-${value}`);
  const svgData = new XMLSerializer().serializeToString(qrCode);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();
  img.onload = () => {
    const leftPadding = 40;
    const bottomPadding = 40;
    const textHeight = 30;
    const padding = 30;

    canvas.width = img.width + leftPadding * 2;
    canvas.height = img.height + padding + textHeight + bottomPadding;

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw some text above the QR code
    let newText = `CHARGER - ${value}`;
    ctx.font = "bold 20px Arial";
    ctx.fillStyle = "black";
    ctx.textAlign = "center";
    ctx.fillText(newText, canvas.width / 2, textHeight);

    ctx.drawImage(img, leftPadding, textHeight + padding / 2);

    const pngFile = canvas.toDataURL("image/jpeg");
    const downloadLink = document.createElement("a");
    downloadLink.download = `${value}.jpeg`;
    downloadLink.href = `${pngFile}`;
    downloadLink.click();
  };
  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};

export default function ChargerForm({ availableLicenses = [], trialPeriod = 7 }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const queryClient = useQueryClient();
  const hasReadOnlyAccess = useAccess(FEATURE.CHARGER, "R");
  const { data: priceGroups } = useList("priceGroups");
  const isCreateCharger = useMatch("/charger/new");
  const isReadOnly = hasReadOnlyAccess && !isCreateCharger;
  const { teamId, teamType, teamName } = useSelectedTeam();
  const { teamState, teamCountry } = useSelectedTeamState();
  const company = useSelectedCompany();
  const [logDetailData, setLogDetailData] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [stateValidationModal, setStateValidationModal] = useState({
    open: false,
    chargerData: null,
    setSubmitting: null,
  });
  const { data: charger, isFetching } = useGetDetail("charger", { id });

  // ── License renewal eligibility ──────────────────────────────────────────
  const isLicenseRenewed =
    !!charger?.license?.renewed_charger_license_id ||
    !!charger?.license?.renewed_charger_license_status;
  const isLicenseExpired = charger?.license_status === enums.LICENSE_STATUS.EXPIRED;
  const isLicenseTrial   = charger?.license?.duration === 'T';
  const today = new Date();
  const isActiveBetweenExpiry =
    charger?.license_status === enums.LICENSE_STATUS.ACTIVE &&
    !isLicenseTrial &&
    charger?.license?.expiry &&
    charger?.license?.final_expiry &&
    today >= new Date(charger.license.expiry) &&
    today <= new Date(charger.license.final_expiry);
  const isInactiveBetweenExpiry =
    charger?.license_status === enums.LICENSE_STATUS.INACTIVE &&
    !isLicenseTrial &&
    charger?.license?.expiry &&
    charger?.license?.final_expiry &&
    today >= new Date(charger.license.expiry) &&
    today <= new Date(charger.license.final_expiry);
  const isQRSupportedGateway =
    charger?.paymentGateway === PAYMENT_GATEWAY["razorpay"].gateway ||
    charger?.paymentGateway === PAYMENT_GATEWAY["stripe"].gateway;

  const shouldShowRenewalUI =
    !isCreateCharger &&
    !isLicenseRenewed &&
    teamType !== 'P' &&
    (isLicenseExpired || isLicenseTrial || isActiveBetweenExpiry || isInactiveBetweenExpiry);

  // ── Renewal scenario data ─────────────────────────────────────────────────
  // Use distinct keys so we don't share isFetching with Charger.js parent,
  // which would cause it to unmount ChargerForm while loading.
  const { data: licensePool } = useQuery(
    ['chargerRenewalLicenses', { url: teamAvailableChargerLicensesUrl(teamId, charger?.charger_type) }],
    fetchWithError,
    {
      enabled: shouldShowRenewalUI && !!teamId && !!charger?.charger_type,
      select: selector,
    }
  );
  const { data: licenseConfig } = useQuery(
    ['chargerRenewalConfig', { url: teamChargerLicenseConfigUrl(teamId) }],
    fetchWithError,
    {
      enabled: shouldShowRenewalUI && !!teamId,
      select: selector,
    }
  );
  const matchingAvailableLicenses = licensePool?.licenses ?? [];
  const [selectedLicensePk, setSelectedLicensePk] = useState('');
  const [renewModalOpen, setRenewModalOpen] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const { mutate: assignLicense, isLoading: isAssigningLicense } = useMutate('addChargerLicense');
  const { mutate: initiateLicenseSale } = useMutate('chargerLicenseConfig', {}, false);

  const handleAssignLicense = () => {
    if (!selectedLicensePk) return;
    assignLicense(
      {
        url: assignChargerLicenseUrl(teamId, id),
        method: 'PUT',
        body: {
          current_charger_license: charger?.license?.license_pk,
          renewal_charger_license: selectedLicensePk,
        },
      },
      {
        onSuccess: () => {
          dispatch(setAlert({ open: true, message: 'License assigned successfully.', severity: enums.SEVERITY.SUCCESS }));
          queryClient.invalidateQueries(queryKeys.charger(teamId, id));
          setSelectedLicensePk('');
        },
        onError: (err) => {
          dispatch(setAlert({ open: true, message: err?.message || 'Failed to assign license.', severity: enums.SEVERITY.ERROR }));
        },
      }
    );
  };

  const handlePurchase = (payload) => {
    initiateLicenseSale(
      {
        url: initiateChargerLicenseSaleUrl,
        method: 'POST',
        body: {
          team_id: teamId,
          user_id: user?.id,
          ...payload,
          redirect_to: `/charger/${charger?.chargepoint_pk}`,
        },
      },
      {
        onSuccess: (data) => {
          setRenewModalOpen(false);
          if (data?.checkoutUrl) {
            window.location.href = data.checkoutUrl;
          } else {
            setPaymentData({ ...data, amount: payload.total_cost });
          }
        },
      }
    );
  };

  const [timeInterval, setTimeInterval] = useState({
    startDate: null,
    endDate: null,
  });
  const [searchData, setSearchData] = useState(true);
  const [isSearchingLogs, setIsSearchingLogs] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const {
    id: userCompanyId,
    paymentGatewayId: userPaymentGatewayId,
  } = user?.company || {};
  const [open, setOpen] = useState(false);
  const [incomingCount, setIncomingCount] = useState(0);
  const [outgoingCount, setOutgoingCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [direction, setDirection] = useState("");
  const [status, setStatus] = useState("");
  const [messageStatus, setMessageStatus] = useState("");
  const [type, setType] = useState("");
  const [recordLimit, setRecordLimit] = useState(100);
  const [errorCount, setErrorCount] = useState(0);
  const [isNewScreen, setIsNewScreen] = useState(true);
  const location = useLocation();

  const {
    data: logsData,
    hasNextPage,
    fetchNextPage,
    refetch,
    isFetching: isLogsFetching,
    isRefetching: isLogsRefetching,
    isFetchingNextPage: isLogsFetchingNextPage,
  } = useInfiniteQuery(
    [
      "viewLogs",
      { url: getTeamUrlV2(viewLogsUrl(charger?.chargepoint_id)) },
    ],
    fetchInfinite,
    {
      enabled: !!charger,
      getNextPageParam: (lastPage, pages) => {
        if (searchData) {
          if (lastPage.length === 0) {
            return;
          }
          return pages.length + 1;
        }
      },
    }
  );

  const handleRefetch = async () => {
    setSearchData(true);
    await refetch();
    setLogDetailData(logsData);
  };

  const errorNotification = (message) => {
    return dispatch(
      setAlert({
        open: true,
        message: message || "Please select a valid time interval",
        severity: enums.SEVERITY.ERROR,
      })
    );
  };

  useEffect(() => {
    if (logsData) {
      setLogDetailData(logsData);
    }
  }, [logsData]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const stripeStatus =
      params.get("stripePaymentStatus") ||
      params.get("stripeStatus") ||
      params.get("paymentStatus");

    if (stripeStatus && stripeStatus.toLowerCase() === "success") {
      dispatch(
        alertSlice.actions.setAlert({
          open: true,
          message: "Stripe payment confirmed. Charger initialising...",
          severity: "success",
        })
      );
      queryClient.invalidateQueries("charger");
    }
  }, [location.search, dispatch, queryClient]);

  function getTime(time) {
    let date = new Date(time).toUTCString();
    return date.split(" ")[4];
  }

  const tabsToShow = useMemo(() => {
    if (id) {
      return ChargerFormTabs;
    }
    return ChargerFormTabs.filter(
      (tab) =>
        tab.value !== "config" &&
        tab.value !== "logs" &&
        tab.value !== "remote operations" &&
        tab.value !== "report_incidents" &&
        tab.value !== "license"
    );
  }, [id]);

  const { mutate, isLoading } = useMutate("chargers");
  const { mutate: genQRMutate, isLoading: isGenQR } = useMutate("generateQR");
  const {
    tabOpened,
    tabOpenedFor,
    data: reduxData,
  } = useSelector(({ tabsCurrentlyOpenedFor }) => tabsCurrentlyOpenedFor);
  const { modalOpen, remoteOperationPerformed, operationDetails } = useSelector(
    ({ remoteOpStatus }) => remoteOpStatus
  );
  const [selectedTab, setSelectedTab] = useState(
    tabOpenedFor === "charger" && tabOpened ? tabOpened : "general"
  );
  const [razorPayQRCodePreview, setRazorPayQRCodePreview] = useState({
    type: "payment",
    open: false,
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadRazorPayQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setRazorPayQRCodePreview({ ...razorPayQRCodePreview, open: false });
        },
      },
    ],
  });

useEffect(() => {
  if (reduxData?.dataForLogs) {
    let startTime = reduxData?.dataForLogs?.starttime
      ? new Date(reduxData.dataForLogs.starttime)
      : null;
    let stopTime = reduxData?.dataForLogs?.stoptime
      ? new Date(reduxData.dataForLogs.stoptime)
      : null;

    setTimeInterval((prev) => ({
      ...prev,
      startDate: startTime,
      endDate: stopTime,
    }));

    if (startTime && stopTime) {
      fetchLogFilterData(startTime, stopTime);
    }
  }
}, [reduxData]);

  const fetchLogFilterData = async (sDate, eDate) => {
    // Convert dates to UTC and extract date/time parts
    let startDate = "";
    let endDate = "";
    let timeStart = "00:00:00";
    let timeEnd = "23:59:59";
    
    if (sDate && sDate !== "") {
      const utcStart = new Date(sDate).toISOString();
      startDate = utcStart.split('T')[0]; // YYYY-MM-DD format in UTC
      timeStart = utcStart.split('T')[1].substring(0, 8); // HH:MM:SS format in UTC
    }
    
    if (eDate && eDate !== "") {
      const utcEnd = new Date(eDate).toISOString();
      endDate = utcEnd.split('T')[0]; // YYYY-MM-DD format in UTC
      timeEnd = utcEnd.split('T')[1].substring(0, 8); // HH:MM:SS format in UTC
    } else if (sDate && sDate !== "") {
      // If no end date, use start date for end date
      endDate = startDate;
    }
    
    if (
      (startDate &&
        endDate &&
        isValidTimeInterval({ start: sDate, end: eDate })) ||
      searchText !== "" ||
      direction !== "" ||
      status !== "" ||
      messageStatus !== "" ||
      type !== ""
    ) {
      setSearchData(false);
      setIsSearchingLogs(true);
      try {
        const response = await axios.get(
          logFilterData(
            charger.chargepoint_id,
            startDate,
            endDate,
            timeStart,
            timeEnd,
            searchText,
            direction,
            status,
            messageStatus,
            type,
            recordLimit
          )
        );
        if (response?.data) {
          setLogDetailData((prev) => ({
            ...prev,
            pages: [response?.data?.data],
          }));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsSearchingLogs(false);
      }
    } else {
      errorNotification("Please select a filter option.");
    }
  };

  const [CMQRCodePreview, setCMQRCodePreview] = useState({
    type: "charger",
    open: false,
    templateVal: (charger && charger?.webapp_url ? charger.webapp_url : process.env.REACT_APP_WEB_APP_ENDPOINT + '/charger/'),
    value: "",
    buttons: [
      {
        btnLabel: "Download",
        action: downloadCMQR,
        params: true,
      },
      {
        btnLabel: "Close",
        action: function () {
          setCMQRCodePreview({ ...CMQRCodePreview, open: false });
        },
      },
    ],
  });

  useEffect(() => {
    if (charger?.webapp_url) {
      setCMQRCodePreview((prev) => ({
        ...prev,
        templateVal: charger.webapp_url,
      }));
    }
  }, [charger]);

    const handlePDF = async () => {
    setLoading(true);
    try {
      Token.setAuthToken();
      const response = await axios.get(
        getChargerInstructionBoardUrl(teamId, id),
        {
          responseType: "blob",
        }
      );

      const existingPDF = await response.data.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPDF);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      // Generate and Embed QR Code
      let qrCodeImage;
      try {
        const qrCodeDataUrl = await QRCode.toDataURL(
          `${charger && charger?.webapp_url}${values["chargepoint_id"]}`
        );
        qrCodeImage = await pdfDoc.embedPng(qrCodeDataUrl);
      } catch (error) {
        console.error("QR Code Generation Error:", error);
      }

      const { height } = firstPage.getSize();

      if (qrCodeImage) {
        const yCoordinate = (height - 165) / 2; // Center the image vertically
        firstPage.drawImage(qrCodeImage, {
          x: 665,
          y: yCoordinate + 210,
          width: 165,
          height: 165,
        });
      }

      const modifiedPDF = await pdfDoc.save();
      const modifiedBlob = new Blob([modifiedPDF], { type: "application/pdf" });
      const blobUrl = window.URL.createObjectURL(modifiedBlob);

      let filename =
        response?.headers["x-filename"]?.trim() || "Instruction_Board.pdf";


      setTimeout(() => {
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, 1500);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnectorPDF = async () => {
    setLoadingPDF(true);
    try {
      Token.setAuthToken();
      const response = await axios.get(
        getChargerInstructionBoardConnectorUrl(teamId, id),
        {
          responseType: "blob",
        }
      );

      const filename =
        response?.headers["x-filename"]?.trim() ||
        "Connector_Instruction_Board.pdf";
      const blobUrl = window.URL.createObjectURL(response.data);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setLoadingPDF(false);
    }
  };

  const hasConnectorsAdded = useCallback((connectors = []) => {
    return connectors.some(
      (connector) =>
        (connector.volt !== "" && connector.connectorType !== "") ||
        (connector.kw !== "" && connector.connectorType !== "")
    );
  }, []);

  const handleRemoteOpsStatusModalClose = () => {
    dispatch(
      remoteOpsStatusSlice.actions.setRemoteOps({
        open: false,
        remoteOperationPerformed: null,
        operationDetails: { chargerId: null, response: null },
      })
    );
  };

  const handleStateValidationContinue = () => {
    const { chargerData, setSubmitting } = stateValidationModal;
    setStateValidationModal({ open: false, chargerData: null, setSubmitting: null });
    processChargerSubmission(chargerData, { setSubmitting });
  };

  const handleStateValidationCancel = () => {
    const { setSubmitting } = stateValidationModal;
    setStateValidationModal({ open: false, chargerData: null, setSubmitting: null });
    
    // Ensure form submission is cancelled
    if (setSubmitting) {
      setSubmitting(false);
    }
  };

  const onSubmit = (chargerData, { setSubmitting }) => {
    // Cross-team validation for company users updating chargers from different teams
    if (company?.companyType === 'P' && charger && user?.role) {
      // Find the original charger's team information from user roles
      const originalChargerTeamId = charger?.companyId;
      const originalTeam = user.role.find(role => role.teamId === originalChargerTeamId);
      if (originalTeam) {
        // This charger belongs to a different team, validate against original team location
        const originalTeamState = originalTeam.teamState;
        const originalTeamCountry = originalTeam.teamCountry;
        
        // Extract charger location values
        let chargerState = chargerData?.state || chargerData?.address?.state;
        let chargerCountry = chargerData?.country || chargerData?.address?.country;
        
        // Normalize values for comparison
        chargerState = typeof chargerState === 'string' ? chargerState.trim().toLowerCase() : chargerState;
        chargerCountry = typeof chargerCountry === 'string' ? chargerCountry.trim().toLowerCase() : chargerCountry;
        const teamStateValue = typeof originalTeamState === 'string' ? originalTeamState.trim().toLowerCase() : originalTeamState;
        const teamCountryValue = typeof originalTeamCountry === 'string' ? originalTeamCountry.trim().toLowerCase() : originalTeamCountry;
        
        // Validate state mismatch
        if (chargerState && teamStateValue && chargerState !== teamStateValue) {
          setStateValidationModal({
            open: true,
            chargerData,
            setSubmitting,
          });
          return;
        }
        
        // Validate country mismatch
        if (chargerCountry && teamCountryValue && chargerCountry !== teamCountryValue) {
          setStateValidationModal({
            open: true,
            chargerData,
            setSubmitting,
          });
          return;
        }
      }
    }

    // State validation for charger creation and updates
    if (company?.companyType !== 'P' && teamState && !is.empty(teamState)) {
      // Try multiple ways to extract state values
      let chargerState = chargerData?.state || chargerData?.address?.state;
      
      // Handle teamState - it could be a string (state name) or an object
      let teamStateValue;
      if (typeof teamState === 'string') {
        // teamState is already the state name
        teamStateValue = teamState;
      }
      
      // Normalize state values (trim and lowercase for comparison)
      chargerState = typeof chargerState === 'string' ? chargerState.trim().toLowerCase() : chargerState;
      teamStateValue = typeof teamStateValue === 'string' ? teamStateValue.trim().toLowerCase() : teamStateValue;
      
      if (chargerState && teamStateValue && chargerState !== teamStateValue) {
        setStateValidationModal({
          open: true,
          chargerData,
          setSubmitting,
        });
        return;
      }
    }

    // Country validation for charger creation and updates
    if (company?.companyType !== 'P' && teamCountry && !is.empty(teamCountry)) {
      // Try multiple ways to extract country values
      let chargerCountry = chargerData?.country || chargerData?.address?.country;
      
      // Handle teamCountry - it could be a string (country name) or an object
      let teamCountryValue;
      if (typeof teamCountry === 'string') {
        // teamCountry is already the country name
        teamCountryValue = teamCountry;
      }
      
      // Normalize country values (trim and lowercase for comparison)
      chargerCountry = typeof chargerCountry === 'string' ? chargerCountry.trim().toLowerCase() : chargerCountry;
      teamCountryValue = typeof teamCountryValue === 'string' ? teamCountryValue.trim().toLowerCase() : teamCountryValue;
      if (chargerCountry && teamCountryValue && chargerCountry !== teamCountryValue) {
        setStateValidationModal({
          open: true,
          chargerData,
          setSubmitting,
        });
        return;
      }
    }

    // Proceed with normal submission
    processChargerSubmission(chargerData, { setSubmitting });
  };

  const processChargerSubmission = (chargerData, { setSubmitting }) => {
    let hasConnectors = !0;

    const sanitizeData = sanitizeValues(chargerData);
    const {
      street,
      houseNumber,
      addressLine3,
      zipCode,
      city,
      country,
      state,
      connectors,
      locationLatitude,
      locationLongitude,
      addressId,
    } = sanitizeData;
    if (is.empty(locationLatitude) || is.empty(locationLongitude)) {
      dispatch(
        setAlert({
          open: true,
          message: "Address is required for the Charge Point",
          severity: enums.SEVERITY.ERROR,
        })
      );
      setSubmitting(false);
      return;
    }
    sanitizeData.address = {
      street,
      houseNumber,
      addressLine1: street,
      addressLine2: houseNumber || "",
      addressLine3: addressLine3 || "",
      zipCode,
      city,
      country,
      state,
    };
    // On update, send the existing addressId so the backend updates the
    // existing address record instead of creating a new one.
    if (!is.nullOrUndefined(id) && !isCreateCharger && !is.nullOrUndefined(addressId)) {
      sanitizeData.address.addressId = addressId;
    }
    delete sanitizeData.addressId;
    sanitizeData.addressLine1 = street;
    sanitizeData.addressLine2 = houseNumber || "";
    sanitizeData.addressLine3 = addressLine3 || "";
    sanitizeData.insertConnectorStatusAfterTransactionMsg = Number(
      sanitizeData.insertConnectorStatusAfterTransactionMsg
    );
    sanitizeData.employeeOrResident = Number(sanitizeData.employeeOrResident);
    sanitizeData.payWithWallet = Number(sanitizeData.payWithWallet);
    sanitizeData.payWithCard = Number(sanitizeData.payWithCard);
    sanitizeData.notificationSettings = {
      notificationRecipients: sanitizeData.notificationRecipients,
      enableNotifications: Number(sanitizeData.enableNotifications),
      OcppStationBooted: Number(sanitizeData.OcppStationBooted),
      OcppStationStatusFailure: Number(sanitizeData.OcppStationStatusFailure),
      OcppStationWebSocketConnected: Number(
        sanitizeData.OcppStationWebSocketConnected
      ),
      OcppStationWebSocketDisconnected: Number(
        sanitizeData.OcppStationWebSocketDisconnected
      ),
      OcppTransactionStarted: Number(sanitizeData.OcppTransactionStarted),
      OcppTransactionEnded: Number(sanitizeData.OcppTransactionEnded),
    };
    const mutateObject = {
      url: getTeamUrl(teamId, chargerUrl),
      method: "POST",
    };
    if (!is.nullOrUndefined(id) && !isCreateCharger) {
      // update charger point if id is undefined
      mutateObject.method = "PUT";
      mutateObject.url = getTeamUrl(teamId, chargerIdUrl(id));
    }

    if (connectors.length === 1) {
      hasConnectors = hasConnectorsAdded(connectors);
      const hasConnectorsHaveNegativeValues = connectors.some((connector) => {
        return Number(connector.kw) < 0 || Number(connector.volt) < 0;
      });

      if (hasConnectorsHaveNegativeValues) {
        dispatch(
          setAlert({
            open: true,
            message: "Kilowatt and Volt cannot be negative",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }

      if (!hasConnectors) {
        dispatch(
          setAlert({
            open: true,
            message: "At least 1 connector is required",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
    }

    if (connectors.length > 0 && hasConnectors) {
      const arePricegroupsPresent = connectors.every(
        ({ priceGroupId }) => !is.empty(priceGroupId)
      );
      if (!arePricegroupsPresent) {
        //TO CHECK WHETHER ALL THE CONNECTORS HAVE A PRICEGROUP SELECTED
        dispatch(
          setAlert({
            open: true,
            message:
              "Every connector should have a pricegroup specified for it",
            severity: enums.SEVERITY.ERROR,
          })
        );
        setSubmitting(false);
        return;
      }
      sanitizeData.connectors = connectors.map((connector, index) => {
        if (!connector?.connectorName) {
          connector["connectorName"] = index + 1;
        }
        return { ...connector, connectorId: index + 1 };
      });
    }

    sanitizeData.photos = !is.empty(sanitizeData.photos)
      ? sanitizeData.photos.filter((photo) => !is.empty(photo))
      : [];
    sanitizeData.amenities = !is.empty(sanitizeData.amenities)
      ? sanitizeData.amenities.filter((amenity) => !is.empty(amenity))
      : [];
    try {
      mutate(
        {
          url: mutateObject.url,
          method: mutateObject.method,
          body: sanitizeData,
        },
        {
          onSuccess: (data) => {
            dispatch(
              tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
                detailsId: "",
                tabOpenedFor: "",
                tabOpened: "",
                data: {},
              })
            );
            navigate("/charger");
          },
          onError: (error) => {
            setSubmitting(false);
          },
        }
      );
      setSubmitting(false);
    } catch (e) {
      setSubmitting(false);
      console.error("Caught Error Outside Mutate:", e);
    }
  };

  const formik = useFormik({
    initialValues: getChargerDefaultValues({ teamId }),
    validationSchema: chargerFormValidationSchema,
    onSubmit: onSubmit,
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    isSubmitting,
    getFieldProps,
    resetForm,
    setFieldValue,
  } = formik;

  const { handleSaveClick } = useTabbedFormErrors({
    formik,
    fieldToTab: chargerFieldToTab,
    tabOrder: chargerTabOrder,
    tabLabels: chargerTabLabels,
    setSelectedTab,
  });

  const handleAddAndDeleteConnectors = (key = null) => {
    const { connectors } = values;
    if (is.null(key) && connectors.length !== 12) {
      setFieldValue("connectors", connectors.concat(initialConnectors));
    }
    if (!is.null(key)) {
      setFieldValue(
        "connectors",
        connectors.filter((c, i) => i !== key)
      );
    }
  };

  const handleAddAndDeleteFAQ = (key = null) => {
    const { faq } = values;
    if (is.null(key) && faq.length !== 10) {
      setFieldValue("faq", faq.concat(initialFaq));
    }

    if (!is.null(key)) {
      setFieldValue(
        "faq",
        faq.filter((c, i) => i !== key)
      );
    }
  };

  // const generateChargerQR = async (chargerId, connectorId) => {
  //   try {
  //     const backendUrl = process.env.REACT_APP_CSMS_API_ENDPOINT;
  //     const qrUrl = `${backendUrl}/cms/v1/transactions/razorpay/qrCode/payment?chargerId=${chargerId}&connectorId=${connectorId}`;
      
  //     const qrCodeImage = await QRCode.toDataURL(qrUrl, {
  //       width: 300,
  //       margin: 2,
  //       color: {
  //         dark: '#000000',
  //         light: '#FFFFFF'
  //       }
  //     });
      
  //     return qrCodeImage;
      
  //   } catch (error) {
  //     console.log(`Error generating QR code: ${error.message}`);
  //   }
  // }

  const handleShowRazorPayQRCode = async (QRCodeUrl) => {
    const gateway = PAYMENT_GATEWAY[charger.paymentGateway];
    if (PAYMENT_TYPE.QRCODE === gateway.type) {
      //const MiddleWareQRCoodeImage = await generateChargerQR(chargerId, value?.connectorId)
      const updatedPreviewObject = {
        ...razorPayQRCodePreview,
        value: QRCodeUrl,
        open: true,
      };
      setRazorPayQRCodePreview(updatedPreviewObject);
    } else if (QRCodeUrl) {
      window.open(QRCodeUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleShowCMQRCode = (chargerId) => {
    const updatedPreviewObject = {
      ...CMQRCodePreview,
      value: chargerId,
      open: true,
    };

    setCMQRCodePreview(updatedPreviewObject);
  };

  const generateQRCode = (connectorId) => {
    const cId = company.companyType === 'P' ? company.id : teamId;
    const selectedCompanyId =
      values?.companyId || charger?.companyId || userCompanyId;
    const selectedPaymentGatewayId =
      values?.paymentGatewayId || charger?.paymentGatewayId || userPaymentGatewayId;

    if (!selectedCompanyId || !selectedPaymentGatewayId) {
      dispatch(
        alertSlice.actions.setAlert({
          open: true,
          severity: "error",
          message: "Missing payment configuration for this charger",
        })
      );
      return;
    }

    const url =
      PAYMENT_GATEWAY["razorpay"].gateway === charger.paymentGateway
        ? getTeamUrl(
            teamId,
            `/charger/${charger?.chargepoint_id}/${
              PAYMENT_GATEWAY[charger.paymentGateway].endpoint
            }`
          )
        : getTeamV3Url(
            teamId,
            `/charger/${charger?.chargepoint_id}/generate_payment_link`
          );
    genQRMutate(
      {
        url,
        method: "POST",
        body: {
          connectorId,
          companyId: cId,
          paymentGatewayId: selectedPaymentGatewayId,
          source: "CMS",
        },
        headers: { Authorization: `Bearer ${Token.get()}` },
      },
      {
        onSuccess: (response) => {
          const paymentLink = response?.data?.paymentLink;
          const gateway = charger?.paymentGateway;
          if (paymentLink) {
            const updatedConnectors = values.connectors.map((connector) => {
              if (connector.connector_pk === connectorId) {
                const existing =
                  typeof connector.qrCodeUrl === "string"
                    ? JSON.parse(connector.qrCodeUrl || "{}")
                    : connector.qrCodeUrl || {};
                return {
                  ...connector,
                  qrCodeUrl: { ...existing, [gateway]: paymentLink },
                };
              }
              return connector;
            });
            setFieldValue("connectors", updatedConnectors, false);
            window.open(paymentLink, "_blank", "noopener,noreferrer");
            dispatch(
              alertSlice.actions.setAlert({
                open: true,
                message: "Stripe payment link opened in a new tab.",
                severity: "success",
              })
            );
          }
          queryClient.invalidateQueries("charger");
        },
      }
    );
  };

  useEffect(() => {
    if (charger && priceGroups) {
      const {
        address,
        notificationSettings,
        insertConnectorStatusAfterTransactionMsg,
        employeeOrResident,
        payWithWallet,
        payWithCard,
        status,
        ...rest
      } = charger;
      const zipcode = address?.zipCode;
      address.houseNumber = address.houseNumber || "";
      dispatch(
        tabsCurrentlyOpenedForSlice.actions.setTabsOpened({
          detailsId: charger.chargepoint_id,
          tabOpenedFor: "charger",
          tabOpened,
          data: reduxData,
        })
      );

      const visibiltyOnPortal = !!charger.showOnPortal;
      let formValues = {
        ...rest,
        ...address,
        showOnPortal: visibiltyOnPortal,
        zipCode: zipcode,
        insertConnectorStatusAfterTransactionMsg:
          !!insertConnectorStatusAfterTransactionMsg,
        employeeOrResident: !!employeeOrResident,
        payWithWallet: !!payWithWallet,
        payWithCard: !!payWithCard,
        status: status === "A" ? "Active" : "Inactive",
      };
      if (notificationSettings) {
        const {
          settings_pk,
          enableNotifications,
          notificationFeatures,
          notificationRecipients,
        } = notificationSettings;

        let allNotificationFeatures;
        if (!is.empty(notificationFeatures)) {
          const selectedFeatures = notificationFeatures.split(",");
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              if (selectedFeatures.includes(feature)) {
                allNotificationFeatures[feature] = true;
              }
              return allNotificationFeatures;
            },
            {}
          );
        } else {
          allNotificationFeatures = NOTIFICATION_CONSTANTS.reduce(
            (allNotificationFeatures, feature) => {
              allNotificationFeatures = {
                ...allNotificationFeatures,
                [feature]: false,
              };
              return allNotificationFeatures;
            },
            {}
          );
        }

        formValues = {
          ...formValues,
          ...allNotificationFeatures,
          settings_pk,
          notificationRecipients,
          enableNotifications: !!enableNotifications,
        };
      } else {
        formValues = {
          ...formValues,
          enableNotifications: false,
          notificationRecipients: "",
          OcppStationBooted: false,
          OcppStationStatusFailure: false,
          OcppStationWebSocketConnected: false,
          OcppStationWebSocketDisconnected: false,
          OcppTransactionStarted: false,
          OcppTransactionEnded: false,
        };
      }
      resetForm({ values: formValues });
    }
  }, [charger, priceGroups, resetForm, dispatch, tabOpened]);

  const deepFilter = (
    message,
    selectedType = "",
    selectedStatus = "",
    messageStatus = ""
  ) => {
    let parsed;
    try {
      parsed = JSON.parse(message);
    } catch {
      return false;
    }

    const messageType = parsed?.[2]; // e.g., "Authorize", "StatusNotification", etc.
    const body = parsed?.[3]?.status;
    const errorCode = parsed?.[3]?.errorCode;
    // Direct match
    if (selectedType) {
      if (typeof messageType === "string" && messageType === selectedType) {
        return true;
      }
    }
    if (selectedStatus) {
      if (typeof body === "string" && body === selectedStatus) {
        return true;
      }
    }
    if (messageStatus) {
      if (
        messageStatus === "Error" &&
        errorCode !== undefined &&
        errorCode !== "NoError"
      ) {
        return true;
      } else if (messageStatus === "Success") {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (logDetailData?.pages) {
      const allLogs = logDetailData?.pages?.flat();

      const incoming = allLogs?.filter(
        (log) => log.messageType === "INCOMING"
      ).length;
      const outgoing = allLogs?.filter(
        (log) => log.messageType === "OUTGOING"
      ).length;
      const ErrorLogs = allLogs?.filter((log) =>
        deepFilter(log.message, "", "", "Error")
      );

      setIncomingCount(incoming || 0);
      setOutgoingCount(outgoing || 0);
      setErrorCount(ErrorLogs?.length || 0);
    }
  }, [logDetailData]);

  const handleTabChange = (e, tab) => {
    setSelectedTab(tab);
  };

  /*
  REMOTE OPERATIONS ESSENTIALS
  */
  const [operation, setOperation] = useState("ChangeAvailability");

  const validationSchema = useMemo(() => {
    const schema =
      remoteOperationConfig[operation]?.reduce(createYupSchema, {}) ?? {};
    return operation && Yup.object().shape(schema);
  }, [operation]);

  const initialValues = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { fieldName, value }) => ({ ...acc, [fieldName]: value ?? "" }),
        {}
      ) ?? {};
    return values;
  }, [operation]);

  const queryKeysDropdown = useMemo(() => {
    const values =
      remoteOperationConfig[operation]?.reduce(
        (acc, { queryKey, usePk, useEmail }) => {
          return queryKey ? [...acc, { queryKey, usePk, useEmail }] : acc;
        },
        []
      ) ?? [];
    return values;
  }, [operation]);

  const isDeactivated = isReadOnly;

  if (isFetching) {
    return <Loader />;
  }

  if (!isCreateCharger && is.empty(charger)) {
    navigate("/dashboard");
    return null;
  }

  function convertArrayOfObjectsToCSV(arrayOfObjects) {
    if (
      !arrayOfObjects ||
      !Array.isArray(arrayOfObjects) ||
      arrayOfObjects.length === 0
    ) {
      return "";
    }
    const csvContent = arrayOfObjects.map((objects) => {
      const rows = objects.map((object) => {
        const values = Object.values(object).map((value) => `"${value}"`);
        return values.join("; ");
      });
      return rows.join("\n");
    });

    return csvContent.join("\n\n");
  }

  const filterLogs = ({
    logs = [],
    searchText = "",
    direction = "",
    status = "",
    type = "",
    messageStatus = "",
  }) => {
    let filteredLogs = [...logs];
    filteredLogs = filteredLogs.filter((log) => {
      const messageLower = log.message?.toLowerCase() || "";

      // Search filter
      const matchesSearch =
        !searchText || messageLower.includes(searchText.toLowerCase());

      // Direction filter
      const matchesDirection =
        !direction ||
        log.messageType?.toUpperCase() === direction.toUpperCase();

      const matchesStatus = !status || deepFilter(log.message, "", status, "");

      const matchesMessageStatus =
        !messageStatus || deepFilter(log.message, "", "", messageStatus);

      const matchesAction = !type || deepFilter(log.message, type, "", "");

      return (
        matchesSearch &&
        matchesDirection &&
        matchesStatus &&
        matchesMessageStatus &&
        matchesAction
      );
    });
    return filteredLogs;
  };

  const filteredLogs = filterLogs({
    logs: logDetailData?.pages?.flat() || [],
    searchText,
    direction,
    status,
    type,
    messageStatus,
  });

  const paginate = (logs, pageSize = 20) => {
    const pages = [];
    for (let i = 0; i < logs.length; i += pageSize) {
      pages.push(logs.slice(i, i + pageSize));
    }
    return pages;
  };

  const paginatedFilteredLogs = {
    pages: paginate(filteredLogs),
    pageParams:
      filteredLogs.length > 0
        ? Array(paginate(filteredLogs).length).fill(undefined)
        : [],
  };

  const isFiltering = !!(
    searchText ||
    direction ||
    status ||
    type ||
    messageStatus
  );

  const handleExport = () => {
    const csv = convertArrayOfObjectsToCSV(
      paginatedFilteredLogs.pages || logDetailData.pages
    );
    downloadCSV(csv, "Logs");
  };

  const handleToggle = (event) => {
    setIsNewScreen(event.target.checked);
  };

  const getPaymentUrl = (qrCodeUrl, gateway) => {
    if (!qrCodeUrl) return null;
    try {
      const parsed =
        typeof qrCodeUrl === "string" ? JSON.parse(qrCodeUrl) : qrCodeUrl;
      return parsed[gateway] || null;
    } catch {
      return null;
    }
  };

  return (
    <>
      {/* Trial License Banner */}
      {charger?.license?.duration === 'T' && charger?.license_status !== enums.LICENSE_STATUS.EXPIRED && (
        <Box
          sx={{
            mb: 2,
            p: 2,
            borderRadius: 2,
            background: 'linear-gradient(135deg, #e3f2fd 0%, #90caf9 50%, #42a5f5 100%)',
            color: '#0d2137',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 4px 16px rgba(66, 165, 245, 0.25)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'60\' height=\'60\' viewBox=\'0 0 60 60\'%3E%3Cg fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.1\'%3E%3Cpath d=\'m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
              opacity: 0.15,
            },
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  mr: 1.5, p: 1, borderRadius: 1.5,
                  backgroundColor: 'rgba(13, 33, 55, 0.1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}
              >
                <Icon icon={ClockFill} width={24} height={24} style={{ color: '#0d2137' }} />
              </Box>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, fontSize: '1.1rem', mb: 0.5 }}
                >
                  Trial License Active
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9, lineHeight: 1.4, fontSize: '0.95rem' }}>
                  This charger is running on a trial license
                  {charger.license?.final_expiry
                    ? `, valid until ${new Date(charger.license.final_expiry).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`
                    : ''
                  }. Purchase a full license from the License section to ensure uninterrupted service after the trial ends.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {/* License Expired Banner */}
      {charger?.license_status === enums.LICENSE_STATUS.EXPIRED && (
        <Box 
          sx={{ 
            mb: 2,
            p: 2,
            borderRadius: 2,
            background: 'linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 50%, #f39c12 100%)',
            color: '#2d3436',
            position: 'relative',
            overflow: 'hidden',
            boxShadow: '0 4px 16px rgba(243, 156, 18, 0.25)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'60\' height=\'60\' viewBox=\'0 0 60 60\'%3E%3Cg fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.1\'%3E%3Cpath d=\'m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
              opacity: 0.1,
              animation: 'float 6s ease-in-out infinite'
            },
            '@keyframes float': {
              '0%, 100%': { transform: 'translateY(0px)' },
              '50%': { transform: 'translateY(-10px)' }
            }
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center'}}>
              <Box 
                sx={{ 
                  mr: 1.5, 
                  p: 1, 
                  borderRadius: 1.5, 
                  backgroundColor: 'rgba(45, 52, 54, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Icon 
                  icon={AlertCircleFill} 
                  width={24} 
                  height={24} 
                  style={{ color: '#2d3436' }} 
                />
              </Box>
              <Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 700, 
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    fontSize: '1.1rem',
                    mb: 0.5
                  }}
                >
                  License Expired!
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    opacity: 0.9,
                    lineHeight: 1.4,
                    fontSize: '0.95rem'
                  }}
                >
                  This charger's license has expired and needs immediate renewal to continue operations.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      
      <TabContext value={selectedTab}>
        <Box
          sx={{
            width: { xs: "800px", sm: "100%" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <RootTabStyle
            indicatorColor="transparent"
            centered
            length={tabsToShow.length}
            onChange={handleTabChange}
          >
            {tabsToShow.map((tab) => (
              <RootTabItemStyles value={tab.value} label={tab.label} />
            ))}
          </RootTabStyle>
        </Box>
        <Card sx={{ p: 0, width: { xs: "800px", sm: "100%" } }}>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              id="charger"
              noValidate
              onSubmit={handleSubmit}
            >
              <TabPanel
                value="general"
                sx={{ width: { xs: "800px", sm: "100%" } }}
              >
                <Grid container spacing={3} className="mb-5">
                  <Grid item xs={6} lg={6}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <FormControl fullWidth size="small">
                        <TextField
                          required
                          disabled={isReadOnly}
                          label="Chargebox Id"
                          size="small"
                          {...getFieldProps("chargepoint_id")}
                          error={Boolean(
                            touched.chargepoint_id && errors.chargepoint_id
                          )}
                          helperText={
                            touched.chargepoint_id && errors.chargepoint_id
                          }
                        />
                      </FormControl>
                      <span class="icon">
                        <Tooltip
                          title="Unique identifier used for system-level management and tracking of charging stations."
                          placement="right"
                        >
                          <Icon
                            icon={AlertCircleFill}
                            className="fs-5"
                            color="#626262"
                          />
                        </Tooltip>
                      </span>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={Boolean(
                        touched.registrationStatus && errors.registrationStatus
                      )}
                    >
                      <InputLabel id="registrationStatus">
                        Registration Status *
                      </InputLabel>
                      <Select
                        labelId="registrationStatus"
                        id="registrationStatus"
                        disabled={isReadOnly}
                        value={values.registrationStatus}
                        label="Registration Status"
                        {...getFieldProps("registrationStatus")}
                      >
                        <MenuItem selected value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Accepted">Accepted</MenuItem>
                        <MenuItem value="Rejected">Rejected</MenuItem>
                      </Select>
                      {touched.registrationStatus && (
                        <FormHelperText>
                          {errors.registrationStatus}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <FormControl fullWidth size="small">
                        <TextField
                          required
                          disabled={isReadOnly}
                          label="Chargebox name"
                          size="small"
                          {...getFieldProps("chargepoint_name")}
                          error={Boolean(
                            touched.chargepoint_name && errors.chargepoint_name
                          )}
                          helperText={
                            touched.chargepoint_name && errors.chargepoint_name
                          }
                        />
                      </FormControl>
                      <span class="icon">
                        <Tooltip
                          title="User-assigned label for easy identification of a charging station."
                          placement="right"
                        >
                          <Icon
                            icon={AlertCircleFill}
                            className="fs-5"
                            color="#626262"
                          />
                        </Tooltip>
                      </span>
                    </Stack>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControl
                      fullWidth
                      size="small"
                      error={Boolean(
                        touched.charger_type && errors.charger_type
                      )}
                    >
                      <InputLabel id="chargerType">Charger Type *</InputLabel>
                      <Select
                        labelId="chargerType"
                        id={`chargerTypeId-${values.charger_type}`}
                        disabled={isReadOnly || !isCreateCharger}
                        value={values.charger_type}
                        label="Charger Type"
                        {...getFieldProps("charger_type")}
                        onChange={(e) => {
                          setFieldValue("charger_type", e.target.value);
                          setFieldValue("license_pk", "");
                        }}
                      >
                        <MenuItem value="AC">AC</MenuItem>
                        <MenuItem value="DC">DC</MenuItem>
                      </Select>
                      {touched.charger_type && (
                        <FormHelperText>{errors.charger_type}</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>

                  {isCreateCharger && (() => {
                    const licensesForType = availableLicenses.filter(
                      (l) => l.charger_type === values.charger_type
                    );
                    return licensesForType.length === 0 ? (
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            p: 1.5,
                            borderRadius: 1.5,
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1.5,
                            bgcolor: '#fff8e1',
                            border: '1px solid #ffe082',
                          }}
                        >
                          <Icon
                            icon={AlertCircleFill}
                            width={20}
                            height={20}
                            style={{ color: '#f9a825', marginTop: 2, flexShrink: 0 }}
                          />
                          <Box>
                            <Typography variant="body2" fontWeight={600} sx={{ color: '#5d4037', mb: 0.25 }}>
                              No {values.charger_type} Charger License Available
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#5d4037' }}>
                              No paid {values.charger_type} charger license is currently available for this team. This charger will be provisioned with a trial license valid for {trialPeriod} day{trialPeriod !== 1 ? 's' : ''}. To ensure uninterrupted service, please purchase a full license from the License section at your earliest convenience.
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ) : (
                      <Grid item xs={6} lg={6}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={Boolean(touched.license_pk && errors.license_pk)}
                        >
                          <InputLabel id="licenseLabel">License</InputLabel>
                          <Select
                            labelId="licenseLabel"
                            label="License"
                            value={values.license_pk}
                            {...getFieldProps("license_pk")}
                          >
                            {licensesForType.map((l) => (
                              <MenuItem key={l.license_pk} value={l.license_pk} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5, py: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                  <Typography variant="body2" fontWeight={600}>{l.license_id}</Typography>
                                  <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
                                    <Box sx={{ px: 1, py: 0.2, borderRadius: 1, fontSize: 11, fontWeight: 600, bgcolor: l.charger_type === 'AC' ? '#e8f5e9' : '#e3f2fd', color: l.charger_type === 'AC' ? '#2e7d32' : '#1565c0' }}>
                                      {l.charger_type}
                                    </Box>
                                    <Box sx={{ px: 1, py: 0.2, borderRadius: 1, fontSize: 11, fontWeight: 600, bgcolor: l.duration === 'M' ? '#fff3e0' : l.duration === 'O' ? '#e8f5e9' : l.duration === 'T' ? '#fce4ec' : '#f3e5f5', color: l.duration === 'M' ? '#e65100' : l.duration === 'O' ? '#2e7d32' : l.duration === 'T' ? '#c62828' : '#6a1b9a' }}>
                                      {getLicenseDurationLabel(l.duration)}
                                    </Box>
                                  </Box>
                                </Box>
                                <Typography variant="caption" color="text.secondary">
                                  Status: {l.status}
                                  {l.created_at && (
                                    <> &nbsp;·&nbsp; Purchased: {format(new Date(l.created_at), 'dd MMM yyyy, HH:mm')}</>
                                  )}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.license_pk && errors.license_pk && (
                            <FormHelperText>{errors.license_pk}</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    );
                  })()}

                  {!isCreateCharger && (
                    <Grid item xs={12} lg={2} sm={2}>
                      <LoadingButton
                        size="small"
                        type="button"
                        variant="contained"
                        startIcon={getIcon(downloadFill, 20, 20)}
                        // disabled={value.qrCodeUrl ? false : true}
                        onClick={() =>
                          handleShowCMQRCode(values["chargepoint_id"])
                        }
                        sx={{ fontSize: "10.5px" }}
                      >
                        Zynka QR Code
                      </LoadingButton>
                    </Grid>
                  )}
                  {!isCreateCharger && (
                    <Grid
                      item
                      xs={12}
                      lg={2}
                      sm={2}
                      sx={{ marginLeft: "-24px" }}
                    >
                      <LoadingButton
                        loading={loading}
                        size="small"
                        type="button"
                        variant="contained"
                        startIcon={getIcon(downloadFill, 20, 20)}
                        onClick={handlePDF}
                        sx={{ fontSize: "10.5px", whiteSpace: "nowrap" }}
                      >
                        Instruction board
                      </LoadingButton>
                    </Grid>
                  )}
                  <Grid item xs={12} lg={12}>
                    <FormControl
                      fullWidth
                      error={Boolean(
                        touched.insertConnectorStatusAfterTransactionMsg &&
                          errors.insertConnectorStatusAfterTransactionMsg
                      )}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            {...getFieldProps(
                              "insertConnectorStatusAfterTransactionMsg"
                            )}
                            checked={
                              values.insertConnectorStatusAfterTransactionMsg
                            }
                            disabled={isReadOnly}
                          />
                        }
                        label="Insert connector status after start/stop transaction"
                      />
                      {touched.insertConnectorStatusAfterTransactionMsg && (
                        <FormHelperText>
                          {errors.insertConnectorStatusAfterTransactionMsg}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={3} alignItems="center">
                  {values.connectors.map((value, index) => {
                    const paymentUrl = getPaymentUrl(
                      value.qrCodeUrl,
                      charger?.paymentGateway
                    );
                    return (
                      <>
                      <Grid
                        item
                        xs={12}
                        lg={isCreateCharger ? 2 : 1}
                        sm={isCreateCharger ? 2 : 1}
                      >
                        <FormControl fullWidth size="small">
                          <Field name={`connectors[${index}].connectorName`}>
                            {({ field, form: { touched, errors }, meta }) => (
                              <TextField
                                disabled={isReadOnly}
                                label="Name"
                                size="small"
                                defaultValue={value.connectorName}
                                {...field}
                                error={touched.connectors && errors.connectors}
                              />
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4} md={3} lg={2}>
                        <FormControl
                          fullWidth
                          size="small"
                          error={touched.connectors && errors.connectors}
                        >
                          <InputLabel id="priceGroupLabel">
                            Price Group
                          </InputLabel>
                          <Field name={`connectors[${index}].priceGroupId`}>
                            {({ field, form: { touched, errors }, meta }) => (
                              <>
                                <Select
                                  labelId="priceGroupLabel"
                                  id="priceGroup"
                                  disabled={isReadOnly}
                                  defaultValue={value.priceGroupId}
                                  label="Price Group"
                                  {...field}
                                >
                                  <MenuItem selected value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {priceGroups &&
                                    priceGroups.map((group) => (
                                      <MenuItem
                                        key={group.priceGroupId}
                                        value={group.priceGroupId}
                                      >
                                        {group.name}
                                      </MenuItem>
                                    ))}
                                </Select>
                                {touched.priceGroupId && (
                                  <FormHelperText>
                                    {errors.priceGroupId}
                                  </FormHelperText>
                                )}
                              </>
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        lg={isCreateCharger ? 3 : 2}
                        md={3}
                        sm={isCreateCharger ? 4 : 2}
                      >
                        <FormControl
                          fullWidth
                          size="small"
                          error={touched.connectors && errors.connectors}
                        >
                          <InputLabel id="connectorTypeLabel">
                            Connector Type
                          </InputLabel>
                          <Field name={`connectors[${index}].connectorType`}>
                            {({ field, form: { touched, errors }, meta }) => (
                              <>
                                <Select
                                  labelId="connectorTypeLabel"
                                  id="connectorType"
                                  disabled={isReadOnly}
                                  defaultValue={value.connectorType}
                                  label="Connector Type"
                                  {...field}
                                >
                                  <MenuItem selected value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {ConnectorType.map((connector) => (
                                    <MenuItem
                                      key={connector.id}
                                      value={connector.value}
                                    >
                                      {connector.type}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {touched.connectors && (
                                  <FormHelperText>
                                    {errors.connectors}
                                  </FormHelperText>
                                )}
                              </>
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4} md={3} lg={2}>
                        <FormControl fullWidth size="small">
                          <Field name={`connectors[${index}].kw`}>
                            {({ field, form: { touched, errors }, meta }) => (
                              <TextField
                                disabled={isReadOnly}
                                type="number"
                                label="Kilo Watt"
                                size="small"
                                defaultValue={value.kw}
                                {...field}
                                error={touched.connectors && errors.connectors}
                                inputProps={{ min: 0 }}
                                InputProps={{
                                  min: 0,
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      kW
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4} md={2} lg={2}>
                        <FormControl fullWidth size="small">
                          <Field name={`connectors[${index}].volt`}>
                            {({ field, form: { touched, errors }, meta }) => (
                              <TextField
                                disabled={isReadOnly}
                                label="Volt"
                                type="number"
                                size="small"
                                {...field}
                                defaultValue={value.volt}
                                error={touched.connectors && errors.connectors}
                                inputProps={{ min: 0 }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      V
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                      {values.connectors.length > 1 && isCreateCharger && (
                        <Grid item xs={12} lg={1} sm={1}>
                          <Tooltip
                            title="Remove Connector"
                            placement="right-end"
                          >
                            <LoadingButton
                              size="medium"
                              type="button"
                              variant="contained"
                              onClick={() =>
                                handleAddAndDeleteConnectors(index)
                              }
                            >
                              <Icon
                                icon={TrashOutline}
                                fontSize="1.9em"
                                className="fs-5"
                              />
                            </LoadingButton>
                          </Tooltip>
                        </Grid>
                      )}
                      {!isCreateCharger && value.hasOwnProperty("status") && (
                        <GridLabel
                          xs={12}
                          sm={1}
                          lg={1}
                          label="Status"
                          value={value?.status}
                          color={
                            value?.status === "Unavailable" ? "red" : "green"
                          }
                        />
                      )}
                      {!isCreateCharger && value.hasOwnProperty("qrCodeUrl") && isQRSupportedGateway ? (
                        !!paymentUrl ? (
                          <Grid item xs={12} lg={2} sm={2}>
                            <LoadingButton
                              size="small"
                              type="button"
                              disabled={
                                !["available", "preparing"].includes(
                                  value?.status?.toLowerCase()
                                )
                              }
                              variant="contained"
                              startIcon={getIcon(downloadFill, 20, 20)}
                              // disabled={value.qrCodeUrl ? false : true}
                              onClick={() =>
                                //handleShowRazorPayQRCode(charger?.chargepoint_id, value)
                                handleShowRazorPayQRCode(paymentUrl)
                              }
                              sx={{ fontSize: "10.5px" }}
                            >
                              {
                                PAYMENT_GATEWAY[charger?.paymentGateway]
                                  ?.afterButtonText
                              }
                            </LoadingButton>
                          </Grid>
                        ) : (
                          <Grid item xs={12} lg={2} sm={2}>
                            <LoadingButton
                              size="small"
                              type="button"
                              variant="contained"
                              disabled={charger.paymentGateway === PAYMENT_GATEWAY["ICICI"].gateway}
                              startIcon={
                                <Icon
                                  icon={PlusCircleFill}
                                  width={24}
                                  height={24}
                                  color="#ffff"
                                />
                              }
                              onClick={() => generateQRCode(value.connector_pk)}
                              sx={{ fontSize: "10px" }}
                            >
                              {
                                PAYMENT_GATEWAY[charger?.paymentGateway]
                                  ?.beforeButtonText
                              }
                            </LoadingButton>
                          </Grid>
                        )
                      ) : (
                        <></>
                      )}
                    </>
                    );
                  })}
                  {!isCreateCharger && (
                    <Grid item xs={12} lg={2} sm={2}>
                      <Tooltip
                        title={
                          !values.connectors.length
                            ? "No connectors added"
                            : !values.connectors.every(
                                (c) => getPaymentUrl(c.qrCodeUrl, charger?.paymentGateway)
                              )
                            ? isQRSupportedGateway
                              ? "Generate UPI QR code for all connectors to enable this"
                              : "QR code required for all connectors to enable this"
                            : "Download Connector Instruction Board PDF"
                        }
                        placement="top"
                        arrow
                      >
                        <span>
                          <LoadingButton
                            loading={loadingPDF}
                            size="small"
                            type="button"
                            variant="contained"
                            startIcon={getIcon(downloadFill, 20, 20)}
                            onClick={handleConnectorPDF}
                            sx={{ fontSize: "10.5px", whiteSpace: "nowrap" }}
                            disabled={
                              !values.connectors.length ||
                              !values.connectors.every(
                                (c) => getPaymentUrl(c.qrCodeUrl, charger?.paymentGateway)
                              )
                            }
                          >
                            Connector Instruction board
                          </LoadingButton>
                        </span>
                      </Tooltip>
                    </Grid>
                  )}
                  {values.connectors.length !== 12 && isCreateCharger && (
                    <Grid item xs={12} lg={2} sm={2}>
                      <Tooltip
                        title="Add More Connectors"
                        placement="right-end"
                      >
                        <LoadingButton
                          size="medium"
                          type="button"
                          variant="contained"
                          onClick={() => handleAddAndDeleteConnectors()}
                        >
                          <Icon
                            icon={PlusFill}
                            fontSize="1.9em"
                            className="fs-5"
                          />
                        </LoadingButton>
                      </Tooltip>
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={3} className="mb-5">
                  <Grid item xs={12} lg={12}>
                    <Typography
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      misc
                    </Typography>
                    <Divider className="text-muted" />
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <TextField
                        label="Description"
                        size="small"
                        disabled={isReadOnly}
                        {...getFieldProps("description")}
                        error={Boolean(touched.name && errors.name)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <TextField
                        label="Admin Address"
                        size="small"
                        disabled={isReadOnly}
                        {...getFieldProps("adminAddress")}
                        error={Boolean(touched.name && errors.name)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControl fullWidth size="small">
                      <TextField
                        label="Additional Notes"
                        size="small"
                        disabled={isReadOnly}
                        {...getFieldProps("note")}
                        error={Boolean(touched.name && errors.name)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          {...getFieldProps("showOnPortal")}
                          checked={values.showOnPortal}
                        />
                      }
                      label="Make Charger public"
                      labelPlacement="start"
                    />
                  </Grid>

                  {charger && (
                    <>
                      <Grid item xs={12} lg={6}>
                        <Stack direction="row" spacing={3}>
                          <Typography
                            textTransform="capitalize"
                            fontWeight="500"
                            gutterBottom
                          >
                            Charger Created:
                          </Typography>
                          <Typography gutterBottom>
                            {yearFirstDateTimeFormat(charger?.createdDate)}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <Stack direction="row" spacing={3}>
                          <Typography
                            textTransform="capitalize"
                            fontWeight="500"
                            gutterBottom
                          >
                            Last Connected On:
                          </Typography>
                          <Typography gutterBottom>
                            {yearFirstDateTimeFormat(charger?.lastHeartbeatTimestamp)}
                          </Typography>
                        </Stack>
                      </Grid>
                    </>
                  )}

                </Grid>
              </TabPanel>

              <TabPanel value="address">
                <Address
                  getFieldProps={getFieldProps}
                  setFieldValue={setFieldValue}
                  formValues={values}
                  notDisplayTitle={true}
                  displayedFor="charger"
                  errors={errors}
                  touched={touched}
                  isReadOnly={isReadOnly}
                />
              </TabPanel>

              <TabPanel value="license">
                <Grid container spacing={3} alignItems="flex-start">
                  {charger?.license ? (
                    <Grid item xs={12} md={6} lg={6}>
                      <Card sx={{ overflow: 'hidden' }}>
                        {/* Card header */}
                        <Box sx={{ px: 3, py: 1.5 }}>
                          <Typography variant="subtitle1" fontWeight={600} sx={{ lineHeight: 1, m: 0 }}>
                            License Information
                          </Typography>
                        </Box>

                        {/* Fields */}
                        <Box sx={{ px: 3 }}>
                          {/* License ID — full width row */}
                          <Box sx={{ py: 1.5 }}>
                            <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                              LICENSE ID
                            </Typography>
                            <Typography variant="body2" fontWeight={600} sx={{ fontFamily: 'monospace', letterSpacing: 0.3 }}>
                              {charger.license?.license_id || 'N/A'}
                            </Typography>
                          </Box>

                          {/* Status + Duration side by side */}
                          <Grid container sx={{ py: 1.5 }}>
                            <Grid item xs={6}>
                              <Typography variant="caption" color="text.secondary" display="block" mb={0.75}>
                                STATUS
                              </Typography>
                              <Box display="flex" alignItems="center" gap={0.75}>
                                <Box
                                  sx={{
                                    width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                                    backgroundColor: charger.license?.status === 'ACTIVE' ? 'success.main' : 'error.main',
                                  }}
                                />
                                <Typography
                                  variant="body2"
                                  fontWeight={600}
                                  color={charger.license?.status === 'ACTIVE' ? 'success.main' : 'error.main'}
                                >
                                  {charger.license?.status || 'N/A'}
                                </Typography>
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography variant="caption" color="text.secondary" display="block" mb={0.75}>
                                DURATION
                              </Typography>
                              <Box
                                sx={{
                                  display: 'inline-flex',
                                  px: 1.25, py: 0.25,
                                  borderRadius: 1,
                                  fontSize: 12,
                                  fontWeight: 700,
                                  bgcolor: charger.license?.duration === 'M' ? '#fff3e0'
                                    : charger.license?.duration === 'O' ? '#e8f5e9'
                                    : charger.license?.duration === 'T' ? '#e3f2fd'
                                    : '#f3e5f5',
                                  color: charger.license?.duration === 'M' ? '#e65100'
                                    : charger.license?.duration === 'O' ? '#2e7d32'
                                    : charger.license?.duration === 'T' ? '#1565c0'
                                    : '#6a1b9a',
                                }}
                              >
                                {getLicenseDurationLabel(charger.license?.duration) || 'Not specified'}
                              </Box>
                            </Grid>
                          </Grid>

                          {/* Expiry + Final Expiry side by side */}
                          <Grid container sx={{ py: 2 }}>
                            <Grid item xs={6}>
                              <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                                EXPIRY DATE
                              </Typography>
                              <Typography variant="body2" fontWeight={500}>
                                {charger.license?.expiry
                                  ? new Date(charger.license.expiry).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
                                  : '—'
                                }
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography variant="caption" color="text.secondary" display="block" mb={0.5}>
                                FINAL EXPIRY
                              </Typography>
                              <Typography variant="body2" fontWeight={500}>
                                {charger.license?.final_expiry
                                  ? new Date(charger.license.final_expiry).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
                                  : '—'
                                }
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Card>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <Card sx={{ p: 4, textAlign: 'center' }}>
                        <Icon
                          icon="eva:alert-circle-outline"
                          width={48}
                          height={48}
                          style={{ color: '#ff9800', marginBottom: 16 }}
                        />
                        <Typography variant="h6" color="text.secondary" gutterBottom>
                          No License Information Available
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          License details will be displayed here once available.
                        </Typography>
                      </Card>
                    </Grid>
                  )}

                  {/* ── Renewal / Assign section ─────────────────────────── */}
                  {shouldShowRenewalUI && (
                    <Grid item xs={12} md={6} lg={6}>
                      <Card sx={{ overflow: 'hidden' }}>
                        <Box sx={{ px: 3, py: 1.5 }}>
                          <Typography variant="subtitle1" fontWeight={600} sx={{ lineHeight: 1, m: 0 }}>
                            {isLicenseExpired ? 'License Renewal' : 'Upgrade License'}
                          </Typography>
                        </Box>
                        <Box sx={{ px: 3, py: 2 }}>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                            {isLicenseExpired
                              ? 'This charger\'s license has expired. Assign an available license or purchase a new one to restore service.'
                              : isLicenseTrial
                              ? 'This charger is on a trial license. Assign an available license or purchase a new one before the trial ends.'
                              : 'This charger\'s license is approaching its final expiry. Assign or renew now to avoid interruption.'}
                          </Typography>

                          {matchingAvailableLicenses.length > 0 ? (
                            /* Scenario 1: assign from existing pool */
                            <Stack spacing={2}>
                              <FormControl fullWidth size="small">
                                <InputLabel>Select Available License</InputLabel>
                                <Select
                                  value={selectedLicensePk}
                                  label="Select Available License"
                                  onChange={(e) => setSelectedLicensePk(e.target.value)}
                                >
                                  {matchingAvailableLicenses.map((l) => (
                                    <MenuItem key={l.license_pk} value={l.license_pk}
                                      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5, py: 1 }}>
                                      <Typography variant="body2" fontWeight={600}>{l.license_id}</Typography>
                                      <Stack direction="row" spacing={1}>
                                        <Typography variant="caption" sx={{ bgcolor: '#e3f2fd', color: '#1565c0', px: 0.75, py: 0.25, borderRadius: 1 }}>
                                          {l.charger_type}
                                        </Typography>
                                        <Typography variant="caption" sx={{ bgcolor: '#f3e5f5', color: '#6a1b9a', px: 0.75, py: 0.25, borderRadius: 1 }}>
                                          {getLicenseDurationLabel(l.duration)}
                                        </Typography>
                                      </Stack>
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <LoadingButton
                                variant="contained"
                                loading={isAssigningLicense}
                                disabled={!selectedLicensePk}
                                onClick={handleAssignLicense}
                                fullWidth
                              >
                                Assign License
                              </LoadingButton>
                            </Stack>
                          ) : (
                            /* Scenario 2: no available licenses — purchase flow */
                            <Stack spacing={1.5}>
                              <Typography variant="body2" color="text.secondary"
                                sx={{ bgcolor: 'action.hover', p: 1.5, borderRadius: 1 }}>
                                No available {charger?.charger_type} licenses in your pool. Purchase a new license to continue.
                              </Typography>
                              <Button
                                variant="contained"
                                color="warning"
                                fullWidth
                                onClick={() => setRenewModalOpen(true)}
                              >
                                Purchase License
                              </Button>
                            </Stack>
                          )}
                        </Box>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </TabPanel>

              <TabPanel value="settings">
                <Grid container>
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      Charger Configuration
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    px={2}
                  >
                    <Grid item>
                      <Typography variant="body2" fontWeight={500}>
                        WebSocket Configuration URL
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        View the charger’s WebSocket endpoint configuration
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="outlined"
                        startIcon={<Icon icon="mdi:cog" width={18} />}
                        onClick={() => setOpen(true)}
                        sx={{ minWidth: 130 }}
                        disabled={!charger?.charger_configuration_url}
                      >
                        View Config
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      Payment Options
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          {...getFieldProps("employeeOrResident")}
                          checked={values.employeeOrResident}
                        />
                      }
                      label="Employee / Resident (OTP)"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          {...getFieldProps("payWithWallet")}
                          checked={values.payWithWallet}
                        />
                      }
                      label="Pay With Wallet"
                      labelPlacement="start"
                    />
                  </Grid>
                  <Grid item xs={6} lg={6}>
                    <FormControlLabel
                      control={
                        <Switch
                          {...getFieldProps("payWithCard")}
                          checked={values.payWithCard}
                        />
                      }
                      label="Pay With Card"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      Mail Notification Settings
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={6} lg={12}>
                    <Stack>
                      <FormControlLabel
                        control={
                          <Switch
                            {...getFieldProps("enableNotifications")}
                            checked={values.enableNotifications}
                          />
                        }
                        label="Enable Notification"
                        labelPlacement="start"
                      />
                      {values?.enableNotifications && (
                        <>
                          <Stack direction="column" spacing={1} my={3} mx={2}>
                            <InputLabel
                              id="notification-recipients-label"
                              sx={{ color: "inherit" }}
                            >
                              Recepients Of All The Enabled Notifications
                            </InputLabel>
                            <FormControl>
                              <TextField
                                required
                                multiline
                                sx={{ width: "400px" }}
                                rows={4}
                                id="notification-recipients"
                                label="Recipients"
                                {...getFieldProps("notificationRecipients")}
                                error={Boolean(
                                  touched.notificationRecipients &&
                                    errors.notificationRecipients
                                )}
                                helperText={
                                  touched.notificationRecipients &&
                                  errors.notificationRecipients
                                }
                              />
                            </FormControl>
                          </Stack>
                          <Typography
                            sx={{ m: 2 }}
                            variant="subtitle2"
                            className="mb-2 text-uppercase"
                          >
                            Notify When....
                          </Typography>
                          <Grid container>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps("OcppStationBooted")}
                                    checked={values.OcppStationBooted}
                                  />
                                }
                                label="A Boot Notification Is Sent"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps(
                                      "OcppStationStatusFailure"
                                    )}
                                    checked={values.OcppStationStatusFailure}
                                  />
                                }
                                label="A Connector Gets Faulted"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps(
                                      "OcppStationWebSocketConnected"
                                    )}
                                    checked={
                                      values.OcppStationWebSocketConnected
                                    }
                                  />
                                }
                                label="Charging Station Connects"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps(
                                      "OcppStationWebSocketDisconnected"
                                    )}
                                    checked={
                                      values.OcppStationWebSocketDisconnected
                                    }
                                  />
                                }
                                label="Charging Station Disconnects"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps("OcppTransactionStarted")}
                                    checked={values.OcppTransactionStarted}
                                  />
                                }
                                label="A Transaction Starts"
                                labelPlacement="start"
                              />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    {...getFieldProps("OcppTransactionEnded")}
                                    checked={values.OcppTransactionEnded}
                                  />
                                }
                                label="A Transaction Stops"
                                labelPlacement="start"
                              />
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Stack>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      Admin Settings
                    </Typography>
                    <Divider className="text-muted" variant="fullWidth" />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl size="small">
                      <TextField
                        required
                        disabled={isReadOnly}
                        label="Tolerance level (in watts)"
                        type="number"
                        size="small"
                        {...getFieldProps("tolerance_watt")}
                        error={Boolean(
                          touched.tolerance_watt && errors.tolerance_watt
                        )}
                        helperText={
                          touched.tolerance_watt && errors.tolerance_watt
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl size="small">
                      <TextField
                        required
                        disabled={isReadOnly}
                        label="Meter Interval (in sec)"
                        type="number"
                        size="small"
                        {...getFieldProps("meter_interval_sec")}
                        error={Boolean(
                          touched.meter_interval_sec &&
                            errors.meter_interval_sec
                        )}
                        helperText={
                          touched.meter_interval_sec &&
                          errors.meter_interval_sec
                        }
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="config"></TabPanel>

              <TabPanel value="logs">
                <Grid container height={30}>
                  <Grid item lg={3} display="flex" alignItems="center" gap={2}>
                    <Icon icon="mdi:monitor" width={24} />
                    <Typography variant="h5" width={200}>
                      {isNewScreen
                        ? "Switch to Old View"
                        : "Switch to New View"}
                    </Typography>
                  </Grid>
                  <Grid item lg={8}></Grid>
                  <Grid item lg={1}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isNewScreen}
                          onChange={handleToggle}
                          color="success"
                        />
                      }
                      labelPlacement="start"
                      sx={{
                        px: 1.5,
                        py: 0.5,
                        backgroundColor: "transparent",
                        border: "none",
                        borderRadius: "999px",
                        width: "fit-content",
                      }}
                    />
                  </Grid>
                </Grid>
                <Divider className="text-muted" />

                {/* Toggle screen content */}
                <Box mt={3}>
                  {isNewScreen ? (
                    <>
                      <Box>
                        <Grid container spacing={2}>
                          {[
                            {
                              label: "Total Messages",
                              value: `${
                                (logDetailData &&
                                  logDetailData.pages?.flat()?.length) ||
                                0
                              }`,
                              icon: (
                                <Icon
                                  icon="mdi:magnify"
                                  color="#2b2d2dff"
                                  width={36}
                                  height={36}
                                />
                              ),
                            },
                            {
                              label: "Incoming",
                              value: `${incomingCount}`,
                              icon: (
                                <Icon
                                  icon="mdi:arrow-bottom-left"
                                  color="#1976d2"
                                  width={36}
                                  height={36}
                                />
                              ),
                            },
                            {
                              label: "Outgoing",
                              value: `${outgoingCount}`,
                              icon: (
                                <Icon
                                  icon="mdi:arrow-top-right"
                                  color="#2e7d32"
                                  width={36}
                                  height={36}
                                />
                              ),
                            },
                            {
                              label: "Errors",
                              value: `${errorCount}`,
                              icon: (
                                <Icon
                                  icon="mdi:close-circle"
                                  color="#d53e3eff"
                                  width={36}
                                  height={36}
                                />
                              ),
                            },
                          ].map(({ label, value, icon }, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                              <Paper
                                elevation={3}
                                sx={{
                                  p: 2,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  <Typography variant="subtitle2">
                                    {label}
                                  </Typography>
                                  <Typography
                                    variant="h5"
                                    color={icon.props.color}
                                  >
                                    {value}
                                  </Typography>
                                </Box>
                                {icon}
                              </Paper>
                            </Grid>
                          ))}
                        </Grid>
                      </Box>
                      <Box
                        mt={4}
                        mb={2}
                        border={1}
                        borderColor="#e0e0e0"
                        p={2}
                        borderRadius={1}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                          mb={2}
                        >
                          <Typography variant="h6" mb={2}>
                            Filter & Export Logs
                          </Typography>
                          <Box sx={{ display: "flex", gap: "1rem" }}>
                            {logsData?.pages[0]?.length > 0 && (
                              <Button
                                variant="contained"
                                startIcon={getIcon(downloadFill)}
                                onClick={handleExport}
                                size="large"
                              >
                                Export CSV
                              </Button>
                            )}
                            <Tooltip placement="bottom" title="Reload">
                              <LoadingButton
                                variant="contained"
                                onClick={handleRefetch}
                                loading={isLogsFetching || isLogsRefetching}
                                loadingIndicator="Refreshing...."
                                size="large"
                              >
                                <Icon icon={RefreshFill} />
                                <Typography sx={{ ml: 1 }}>Refresh</Typography>
                              </LoadingButton>
                            </Tooltip>
                          </Box>
                        </Box>

                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} md={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <Grid item xs={12} md={12}>
                                <DateTimePicker
                                  renderInput={(props) => (
                                    <TextField
                                      {...props}
                                      value={timeInterval.startDate}
                                      error={false}
                                    />
                                  )}
                                  format="dd/MM/yyyy hh:mm:ss a"
                                  label="Start Date/Time"
                                  value={timeInterval.startDate}
                                  onChange={(newVal) =>
                                    setTimeInterval((prev) => ({
                                      ...prev,
                                      startDate: newVal,
                                    }))
                                  }
                                />
                              </Grid>
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={12} md={3}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <Grid item xs={12} md={12}>
                                <DateTimePicker
                                  renderInput={(props) => (
                                    <TextField
                                      {...props}
                                      value={timeInterval.endDate}
                                      error={false}
                                    />
                                  )}
                                  format="dd/MM/yyyy hh:mm:ss a"
                                  label="End Date/Time"
                                  value={timeInterval.endDate}
                                  onChange={(newVal) =>
                                    setTimeInterval((prev) => ({
                                      ...prev,
                                      endDate: newVal,
                                    }))
                                  }
                                />
                              </Grid>
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              placeholder="Search logs..."
                              InputProps={{
                                endAdornment: (
                                  <Icon
                                    icon="mdi:magnify"
                                    width={25}
                                    height={25}
                                  />
                                ),
                              }}
                              onChange={(e) => setSearchText(e.target.value)}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={2}>
                            <TextField
                              fullWidth
                              select
                              label="Direction"
                              value={direction}
                              onChange={(e) => setDirection(e.target.value)}
                            >
                              <MenuItem value="">All Directions</MenuItem>
                              {Direction.map((d) => (
                                <MenuItem value={d.value}>{d.label}</MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <TextField
                              fullWidth
                              select
                              label="All Message Status"
                              value={messageStatus}
                              onChange={(e) => setMessageStatus(e.target.value)}
                            >
                              <MenuItem value="">All Message Status</MenuItem>
                              {AllMessageStatus.map((d) => (
                                <MenuItem value={d.value}>{d.label}</MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <TextField
                              fullWidth
                              select
                              label="All Status"
                              value={status}
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <MenuItem value="">All Status</MenuItem>
                              {AllStatus.map((d) => (
                                <MenuItem value={d.value}>{d.label}</MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <TextField
                              fullWidth
                              select
                              label="All Types"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            >
                              <MenuItem value="">ALL Types</MenuItem>
                              {AllTypes.map((d) => (
                                <MenuItem value={d.value}>{d.label}</MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <TextField
                              fullWidth
                              select
                              label="Record Limit"
                              value={recordLimit}
                              onChange={(e) => setRecordLimit(e.target.value)}
                            >
                              <MenuItem value={100}>100</MenuItem>
                              <MenuItem value={500}>500</MenuItem>
                              <MenuItem value={1000}>1000</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={1}>
                            <LoadingButton
                              variant="contained"
                              loading={isSearchingLogs}
                              onClick={() =>
                                fetchLogFilterData(
                                  timeInterval.startDate,
                                  timeInterval.endDate
                                )
                              }
                              size="large"
                            >
                              Search
                            </LoadingButton>
                          </Grid>
                        </Grid>
                      </Box>
                      {(isLogsFetching && !isLogsFetchingNextPage) || isSearchingLogs ? (
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                          <CircularProgress />
                        </Box>
                      ) : logsData?.pages[0]?.length > 0 ? (
                        filteredLogs.length > 0 ? (
                          <LogsData
                            data={paginatedFilteredLogs}
                            fetchNextPage={fetchNextPage}
                            hasNextPage={hasNextPage}
                          />
                        ) : isFiltering ? (
                          <Typography sx={{ textAlign: "center", mt: 6 }}>
                            No Logs Found
                          </Typography>
                        ) : (
                          <LogsData
                            data={logDetailData}
                            fetchNextPage={fetchNextPage}
                            hasNextPage={hasNextPage}
                          />
                        )
                      ) : (
                        <Typography sx={{ textAlign: "center", mt: 6 }}>
                          No Logs Found
                        </Typography>
                      )}
                    </>
                  ) : (
                    <>
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        marginBottom={3}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: "1rem",
                            placeItems: "center",
                          }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid item xs={12} md={6}>
                              <DateTimePicker
                                renderInput={(props) => (
                                  <TextField
                                    {...props}
                                    value={timeInterval.startDate}
                                    error={false}
                                  />
                                )}
                                format="dd/MM/yyyy hh:mm:ss a"
                                label="Start Date/Time"
                                value={timeInterval.startDate}
                                onChange={(newVal) =>
                                  setTimeInterval((prev) => ({
                                    ...prev,
                                    startDate: newVal,
                                  }))
                                }
                              />
                            </Grid>
                          </LocalizationProvider>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid item xs={12} md={6}>
                              <DateTimePicker
                                renderInput={(props) => (
                                  <TextField
                                    {...props}
                                    value={timeInterval.endDate}
                                    error={false}
                                  />
                                )}
                                format="dd/MM/yyyy hh:mm:ss a"
                                label="End Date/Time"
                                value={timeInterval.endDate}
                                onChange={(newVal) =>
                                  setTimeInterval((prev) => ({
                                    ...prev,
                                    endDate: newVal,
                                  }))
                                }
                              />
                            </Grid>
                          </LocalizationProvider>
                          <TextField
                            select
                            label="Record Limit"
                            value={recordLimit}
                            onChange={(e) => setRecordLimit(e.target.value)}
                            sx={{ minWidth: 120 }}
                          >
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                            <MenuItem value={1000}>1000</MenuItem>
                          </TextField>
                          <LoadingButton
                            variant="contained"
                            loading={isSearchingLogs}
                            onClick={() =>
                              fetchLogFilterData(
                                timeInterval.startDate,
                                timeInterval.endDate
                              )
                            }
                          >
                            Search
                          </LoadingButton>
                        </Box>
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                          {logsData?.pages[0]?.length > 0 && (
                            <Button
                              variant="contained"
                              startIcon={getIcon(downloadFill)}
                              onClick={handleExport}
                            >
                              Export CSV
                            </Button>
                          )}
                          <Tooltip placement="bottom" title="Reload">
                            <LoadingButton
                              variant="contained"
                              onClick={handleRefetch}
                              loading={isLogsFetching || isLogsRefetching}
                              loadingIndicator="Refreshing...."
                            >
                              <Icon icon={RefreshFill} />
                              <Typography sx={{ ml: 1 }}>Refresh</Typography>
                            </LoadingButton>
                          </Tooltip>
                        </Box>
                      </Stack>
                      {(isLogsFetching && !isLogsFetchingNextPage) || isSearchingLogs ? (
                        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
                          <CircularProgress />
                        </Box>
                      ) : logsData?.pages[0]?.length > 0 ? (
                        <OldLogsData
                          data={logDetailData}
                          fetchNextPage={fetchNextPage}
                          hasNextPage={hasNextPage}
                        />
                      ) : (
                        <Typography sx={{ textAlign: "center", mt: 6 }}>
                          No Logs Found
                        </Typography>
                      )}
                    </>
                  )}
                </Box>
              </TabPanel>

              <TabPanel value="operating_instruction">
                <Grid container spacing={3} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      FAQ
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12} textAlign="right">
                    {values?.faq?.length !== 10 && (
                      <Grid item xs={12} lg={12} sm={12}>
                        <Tooltip
                          title="Add More Connectors"
                          placement="right-end"
                        >
                          <LoadingButton
                            size="medium"
                            type="button"
                            variant="contained"
                            onClick={() => handleAddAndDeleteFAQ()}
                          >
                            <Icon
                              icon={PlusFill}
                              fontSize="1.9em"
                              className="fs-5"
                            />
                          </LoadingButton>
                        </Tooltip>
                      </Grid>
                    )}
                  </Grid>
                  {values?.faq?.map((value, i) => (
                    <>
                      <Grid item xs={6} lg={6}>
                        <Stack direction="column" gap={2}>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].id`}>
                              {({ field }) => (
                                <input
                                  type="hidden"
                                  defaultValue={value.id}
                                  {...field}
                                />
                              )}
                            </Field>
                            <Field name={`faq[${i}].question`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  disabled={isReadOnly}
                                  label={`Question-${i + 1}`}
                                  size="small"
                                  defaultValue={value.question}
                                  {...field}
                                  error={touched.question && errors.question}
                                />
                              )}
                            </Field>
                          </FormControl>
                          <FormControl fullWidth size="small">
                            <Field name={`faq[${i}].answer`}>
                              {({ field, form: { touched, errors } }) => (
                                <TextField
                                  multiline
                                  rows={4}
                                  id=""
                                  label={`Answer-${i + 1}`}
                                  error={touched.answer && errors.answer}
                                  {...field}
                                />
                              )}
                            </Field>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </>
                  ))}
                </Grid>
              </TabPanel>

              <TabPanel value="report_incidents">
                <Grid container spacing={3} className="mb-5">
                  <Grid item xs={12} lg={12} marginBottom={2}>
                    <Typography
                      sx={{ ml: 2 }}
                      variant="subtitle1"
                      className="mb-2 text-uppercase"
                    >
                      REPORTED INCIDENTS
                    </Typography>
                    <Divider className="text-muted" variant="middle" />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <BaseTable
                      rows={values.report_issues ?? []}
                      columns={reportIssuesColumn}
                      loading={isFetching}
                      getRowId={(row) => row.serial_number}
                      showExportCsvBtn={false}
                      csvMorphemes="chargers"
                      pageSize={10}
                      isReadOnly={isReadOnly}
                    />
                  </Grid>
                </Grid>
              </TabPanel>
              {!hideForTabs.includes(selectedTab) && (
                <Stack
                  direction="row"
                  spacing={2}
                  alignItem="center"
                  justifyContent="center"
                >
                  {!isReadOnly && (
                    <Box
                      sx={{
                        display: "flex", // Align buttons horizontally
                        gap: 2, // Space between buttons
                        mt: 2, // Adjust the overall margin above the button container
                        position: "relative", // Enable fine-tuning
                        top: "-10px", // Move both buttons slightly upward
                      }}
                    >
                      <LoadingButton
                        size="large"
                        type="button"
                        variant="contained"
                        disabled={isReadOnly}
                        loading={isSubmitting || isLoading}
                        onClick={handleSaveClick}
                      >
                        Save
                      </LoadingButton>
                      <LoadingButton
                        size="large"
                        type="button"
                        variant="outlined"
                        component={RouterLink}
                        to="/charger"
                      >
                        Cancel
                      </LoadingButton>
                    </Box>
                  )}
                </Stack>
              )}
            </Form>
          </FormikProvider>

          {razorPayQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={razorPayQRCodePreview}
              buttonsArray={razorPayQRCodePreview.buttons}
            />
          )}
          {CMQRCodePreview.open && (
            <ImgPreviewModal
              imageObj={CMQRCodePreview}
              buttonsArray={CMQRCodePreview.buttons}
            />
          )}
          <TabPanel value="remote operations">
            <Box>
              <Typography variant="h4" gutterBottom mb={4}>
                Remote Operation
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={4} md={4}>
                  <FormControl>
                    <FormLabel
                      id="Remote-Operations-Radio-Btns-Group-Label"
                      sx={{ my: 2, color: "#4a8dff" }}
                    >
                      Select Operation
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="Remote-Operations-Radio-Btns-Group-Label"
                      onChange={(event, newValue) => {
                        setOperation(newValue);
                      }}
                      value={operation}
                      name="remote-operations-radio-buttons-group"
                    >
                      {remoteOperations &&
                        remoteOperations.map(({ label, value }) => (
                          <FormControlLabel
                            value={value}
                            control={<Radio />}
                            label={label}
                          />
                        ))}
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={8} md={8} spacing={2}>
                  {operation &&
                    validationSchema &&
                    !is.empty(initialValues) && (
                      <RemoteOperationForm
                        operation={operation}
                        validationSchema={validationSchema}
                        initialValues={initialValues}
                        chargerId={values.chargepoint_id}
                        chargerPk={id}
                        key={operation}
                        queryKeysDropdown={queryKeysDropdown}
                        isReadOnly={isReadOnly}
                      />
                    )}
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </Card>
      </TabContext>
      {modalOpen && remoteOperationPerformed && (
        <RemoteOpsStatusModal
          open={modalOpen}
          onClose={handleRemoteOpsStatusModalClose}
          operation={
            remoteOperations.find(
              (operation) => operation.value === remoteOperationPerformed
            ).label
          }
          responseRow={
            operationDetails.response
              ? [
                  {
                    id: 1,
                    charge_box_id: operationDetails.chargerId,
                    response: operationDetails?.response?.response,
                    error: operationDetails?.response?.errorMessage,
                    details: operationDetails?.response?.details,
                  },
                ]
              : [
                  {
                    id: 1,
                    charge_box_id: operationDetails.chargerId,
                    response: "",
                    error: "",
                    details: "",
                  },
                ]
          }
        />
      )}
      <ChargerConfigModal
        chargerId={charger && charger?.chargepoint_id}
        url={charger && charger?.charger_configuration_url}
        open={open}
        onClose={() => setOpen(false)}
      />

      {/* State Validation Modal */}
      <Dialog
        open={stateValidationModal.open}
        onClose={handleStateValidationCancel}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Location Mismatch</DialogTitle>
        <DialogContent>
          <Typography>
            Some values may vary due to location or system state differences.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStateValidationCancel} color="secondary">
            Cancel
          </Button>
          <LoadingButton
            onClick={handleStateValidationContinue}
            variant="contained"
            color="primary"
          >
            Continue
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <StripePaymentModule
        open={paymentData?.for === 'stripe'}
        onClose={() => setPaymentData(null)}
        clientId={paymentData?.clientId}
        paymentId={paymentData?.paymentId}
        returnUrl={paymentData?.return_url}
        onError={() => setPaymentData(null)}
      />

      <PaytmPaymentModule
        open={paymentData?.for === 'paytm'}
        onClose={() => setPaymentData(null)}
        txnId={paymentData?.txnToken}
        orderId={paymentData?.orderId}
        merchantId={paymentData?.merchantId}
        amount={paymentData?.amount}
        onError={() => setPaymentData(null)}
      />

      {renewModalOpen && (
        <ChargerLicenseModal
          open={renewModalOpen}
          onClose={() => setRenewModalOpen(false)}
          teamName={teamName}
          charger_license_payment_config={licenseConfig?.charger_license_payment_config}
          isOfflinePayment={false}
          chargersToRenew={[{
            charge_box_pk: String(charger?.chargepoint_pk),
            chargebox_id: charger?.chargepoint_id,
            charger_type: charger?.charger_type,
            status: charger?.license_status,
          }]}
          onConfirm={handlePurchase}
        />
      )}
    </>
  );
}
